import { render } from "./tw-pagination.vue?vue&type=template&id=0862cc62"
import script from "./tw-pagination.vue?vue&type=script&lang=js"
export * from "./tw-pagination.vue?vue&type=script&lang=js"
script.render = render

export default script